export default __webpack_public_path__ + "static/media/Cuprum-MediumItalic.11b3a488.ttf";